import React, { useEffect, useState } from 'react';
import BaseDrawer from './BaseDrawer';
import { useAdminData } from '../../contexts/AdminDataContext';
import { Mail, MapPin, Target, Calendar, Gem, Star } from 'lucide-react';
interface UserDetailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string | null;
}
const UserDetailDrawer: React.FC<UserDetailDrawerProps> = ({
  isOpen,
  onClose,
  userId
}) => {
  const {
    users,
    updateUser
  } = useAdminData();
  const user = users.find(u => u.id === userId);
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    luogo: '',
    obiettivi: '',
    status: 'active' as 'active' | 'inactive' | 'suspended'
  });
  useEffect(() => {
    if (user) {
      setFormData({
        nome: user.nome,
        cognome: user.cognome,
        email: user.email,
        luogo: user.luogo,
        obiettivi: user.obiettivi,
        status: user.status
      });
    }
  }, [user]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSave = () => {
    if (userId) {
      updateUser(userId, formData);
      onClose();
    }
  };
  if (!user) return null;
  return <BaseDrawer isOpen={isOpen} onClose={onClose} title="Dettagli Utente" description={`ID: ${user.id}`} footer={<div className="flex gap-3" data-id="element-851">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-852">
            Annulla
          </button>
          <button onClick={handleSave} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors" data-id="element-853">
            Salva modifiche
          </button>
        </div>} data-id="element-850">
      {/* Avatar and Name */}
      <div className="flex items-center gap-4" data-id="element-854">
        <img src={user.avatar} alt={`${user.nome} ${user.cognome}`} className="h-20 w-20 rounded-full object-cover" data-id="element-855" />
        <div data-id="element-856">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-857">
            {user.nome} {user.cognome}
          </h3>
          <p className="text-sm font-normal text-gray-500" data-id="element-858">Utente Greenback</p>
        </div>
      </div>

      {/* Editable Fields */}
      <div className="grid grid-cols-2 gap-4" data-id="element-859">
        <div data-id="element-860">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-861">
            Nome
          </label>
          <input type="text" name="nome" value={formData.nome} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-862" />
        </div>
        <div data-id="element-863">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-864">
            Cognome
          </label>
          <input type="text" name="cognome" value={formData.cognome} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-865" />
        </div>
      </div>

      <div data-id="element-866">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-867">
          Email
        </label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-868" />
      </div>

      <div data-id="element-869">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-870">
          Città
        </label>
        <input type="text" name="luogo" value={formData.luogo} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-871" />
      </div>

      <div data-id="element-872">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-873">
          Obiettivi
        </label>
        <select name="obiettivi" value={formData.obiettivi} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-874">
          <option value="Ridurre plastica" data-id="element-875">Ridurre plastica</option>
          <option value="Vita sostenibile" data-id="element-876">Vita sostenibile</option>
          <option value="Zero waste" data-id="element-877">Zero waste</option>
          <option value="Cosmetici naturali" data-id="element-878">Cosmetici naturali</option>
          <option value="Mobilità green" data-id="element-879">Mobilità green</option>
          <option value="Alimentazione bio" data-id="element-880">Alimentazione bio</option>
          <option value="Energia rinnovabile" data-id="element-881">Energia rinnovabile</option>
          <option value="Ridurre sprechi" data-id="element-882">Ridurre sprechi</option>
          <option value="Vita green" data-id="element-883">Vita green</option>
          <option value="Riciclo attivo" data-id="element-884">Riciclo attivo</option>
        </select>
      </div>

      <div data-id="element-885">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-886">
          Stato Account
        </label>
        <select name="status" value={formData.status} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-887">
          <option value="active" data-id="element-888">Attivo</option>
          <option value="inactive" data-id="element-889">Inattivo</option>
          <option value="suspended" data-id="element-890">Sospeso</option>
        </select>
      </div>

      {/* Read-only Stats */}
      <div className="bg-gray-50 rounded-lg p-4 space-y-3" data-id="element-891">
        <div className="flex items-center gap-3" data-id="element-892">
          <Calendar className="h-5 w-5 text-gray-400" data-id="element-893" />
          <div data-id="element-894">
            <p className="text-xs font-normal text-gray-500" data-id="element-895">Data Iscrizione</p>
            <p className="text-sm font-medium text-gray-900" data-id="element-896">
              {new Date(user.dataIscrizione).toLocaleDateString('it-IT')}
            </p>
          </div>
        </div>
      </div>

      {/* Crediti Diamante */}
      <div className="bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-897">
        <div className="flex items-center gap-2 mb-3" data-id="element-898">
          <Gem className="h-5 w-5 text-blue-600" data-id="element-899" />
          <h4 className="font-semibold text-blue-900" data-id="element-900">Crediti Diamante</h4>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-901">
          <div data-id="element-902">
            <p className="text-xs font-normal text-blue-700" data-id="element-903">Ottenuti</p>
            <p className="text-2xl font-bold text-blue-900" data-id="element-904">
              {user.creditiDiamanteOttenuti.toLocaleString()}
            </p>
          </div>
          <div data-id="element-905">
            <p className="text-xs font-normal text-blue-700" data-id="element-906">Spesi</p>
            <p className="text-2xl font-bold text-blue-900" data-id="element-907">
              {user.creditiDiamanteSpesi.toLocaleString()}
            </p>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t border-blue-200" data-id="element-908">
          <p className="text-xs font-normal text-blue-700" data-id="element-909">Saldo Disponibile</p>
          <p className="text-xl font-bold text-blue-900" data-id="element-910">
            {(user.creditiDiamanteOttenuti - user.creditiDiamanteSpesi).toLocaleString()}
          </p>
        </div>
      </div>

      {/* Crediti Stella */}
      <div className="bg-amber-50 rounded-lg p-4 border border-amber-200" data-id="element-911">
        <div className="flex items-center gap-2 mb-3" data-id="element-912">
          <Star className="h-5 w-5 text-amber-600" data-id="element-913" />
          <h4 className="font-semibold text-amber-900" data-id="element-914">Crediti Stella</h4>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-915">
          <div data-id="element-916">
            <p className="text-xs font-normal text-amber-700" data-id="element-917">Ottenuti</p>
            <p className="text-2xl font-bold text-amber-900" data-id="element-918">
              {user.creditiStellaOttenuti.toLocaleString()}
            </p>
          </div>
          <div data-id="element-919">
            <p className="text-xs font-normal text-amber-700" data-id="element-920">Spesi</p>
            <p className="text-2xl font-bold text-amber-900" data-id="element-921">
              {user.creditiStellaSpesi.toLocaleString()}
            </p>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t border-amber-200" data-id="element-922">
          <p className="text-xs font-normal text-amber-700" data-id="element-923">
            Saldo Disponibile
          </p>
          <p className="text-xl font-bold text-amber-900" data-id="element-924">
            {(user.creditiStellaOttenuti - user.creditiStellaSpesi).toLocaleString()}
          </p>
        </div>
      </div>

      {/* Activity Stats */}
      <div className="bg-green-50 rounded-lg p-4 border border-green-200" data-id="element-925">
        <h4 className="font-semibold text-green-900 mb-3" data-id="element-926">Attività</h4>
        <div className="flex items-center justify-between" data-id="element-927">
          <p className="text-sm font-normal text-green-700" data-id="element-928">Riscatti Totali</p>
          <p className="text-2xl font-bold text-green-900" data-id="element-929">{user.claimFatti}</p>
        </div>
      </div>
    </BaseDrawer>;
};
export default UserDetailDrawer;